import { format } from 'date-fns';
import { Workorder } from '@certhon/models';

export interface DayGroup {
  /** yyyy-MM-dd key. 'unscheduled' for workorders without execution_date. */
  key: string;
  date: Date | null;
  workorders: Workorder[];
  /** Scheduled before the viewed period but still open. */
  isCarryOver: boolean;
}

/**
 * Group workorders per execution day, oldest first, unscheduled last.
 * Days before `periodStart` are flagged as carry-over.
 */
export function groupByDay(
  workorders: Workorder[],
  periodStart: Date,
): DayGroup[] {
  const map = new Map<string, DayGroup>();

  for (const wo of workorders) {
    const date = wo.execution_date ? new Date(wo.execution_date) : null;
    const key = date ? format(date, 'yyyy-MM-dd') : 'unscheduled';

    if (!map.has(key)) {
      map.set(key, {
        key,
        date,
        workorders: [],
        isCarryOver: date ? date < periodStart : true,
      });
    }
    map.get(key)!.workorders.push(wo);
  }

  return Array.from(map.values()).sort((a, b) => {
    if (!a.date) return 1;
    if (!b.date) return -1;
    return a.date.getTime() - b.date.getTime();
  });
}
